export default "__VITE_ASSET__3974a2f7__"